import { render, staticRenderFns } from "./NewsHomePage.vue?vue&type=template&id=fff48e28&scoped=true"
import script from "./NewsHomePage.vue?vue&type=script&lang=js"
export * from "./NewsHomePage.vue?vue&type=script&lang=js"
import style0 from "./NewsHomePage.vue?vue&type=style&index=0&id=fff48e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff48e28",
  null
  
)

export default component.exports